import { computed } from 'vue';
import { GET_EXPERIMENTS } from '#shared/types/getters';

export default function useExperiments() {
  const navExperimentation = useNavExperimentation();
  return computed(() => navExperimentation?.[GET_EXPERIMENTS]);
}
